const playRoutes = {
  otrixPlayHome: {
    path: '/play'
  },
  playExercises: {
    path: '/play/exercises'
  },
  playRoutine: {
    path: '/play/routine'
  },
  playWorkout: {
    path: '/play/workout'
  },
  playForum: {
    path: '/play/forum'
  },
  playMyRank: {
    path: '/play/my-rank'
  },
  playPerformance: {
    path: '/play/performance'
  }
};

export default playRoutes;
